import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Wallet, Menu, X, Sun, Moon } from 'lucide-react';
import { Button } from './ui/button';
import { useTheme } from '../context/ThemeContext';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="dark-header">
      <div className="flex items-center justify-between w-full">
        <Link to="/" className="flex items-center gap-3">
          <img src="/logo.png" alt="MatrixLaunch Logo" className="h-12 w-auto object-contain" />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <Link to="/" className="dark-nav-link">Home</Link>
          <Link to="/projects" className="dark-nav-link">Projects</Link>
          <Link to="/about" className="dark-nav-link">About</Link>
          <Link to="/referral" className="dark-nav-link">Referral</Link>
          <Link to="/contact" className="dark-nav-link">Contact</Link>
        </nav>

        {/* Desktop Actions */}
        <div className="hidden md:flex items-center gap-4">
          <button
            onClick={toggleTheme}
            className="w-10 h-10 flex items-center justify-center rounded-sm border border-white/25 hover:border-brand-primary transition-colors"
            aria-label="Toggle theme"
          >
            {theme === 'dark' ? (
              <Sun className="text-brand-primary" size={20} />
            ) : (
              <Moon className="text-brand-primary" size={20} />
            )}
          </button>
          <Button 
            variant="outline" 
            className="btn-secondary"
            onClick={() => navigate('/login')}
          >
            Login
          </Button>
          <Button 
            className="btn-primary flex items-center gap-2"
            onClick={() => navigate('/signup')}
          >
            Sign Up
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-white"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-20 left-0 w-full border-t z-50" style={{ 
          background: 'var(--bg-primary)', 
          borderColor: 'var(--border-subtle)' 
        }}>
          <nav className="flex flex-col p-6 gap-4">
            <Link to="/" className="dark-nav-link py-2" onClick={() => setMobileMenuOpen(false)}>Home</Link>
            <Link to="/projects" className="dark-nav-link py-2" onClick={() => setMobileMenuOpen(false)}>Projects</Link>
            <Link to="/about" className="dark-nav-link py-2" onClick={() => setMobileMenuOpen(false)}>About</Link>
            <Link to="/referral" className="dark-nav-link py-2" onClick={() => setMobileMenuOpen(false)}>Referral</Link>
            <Link to="/contact" className="dark-nav-link py-2" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
            <div className="flex flex-col gap-3 pt-4" style={{ borderTop: '1px solid var(--border-subtle)' }}>
              <button
                onClick={() => {
                  toggleTheme();
                  setMobileMenuOpen(false);
                }}
                className="w-full p-3 flex items-center justify-center gap-2 rounded-sm border transition-colors"
                style={{ 
                  borderColor: 'var(--border-subtle)',
                  color: 'var(--text-primary)'
                }}
              >
                {theme === 'dark' ? (
                  <>
                    <Sun className="text-brand-primary" size={20} />
                    <span>Light Mode</span>
                  </>
                ) : (
                  <>
                    <Moon className="text-brand-primary" size={20} />
                    <span>Dark Mode</span>
                  </>
                )}
              </button>
              <Button 
                variant="outline" 
                className="btn-secondary w-full"
                onClick={() => {
                  navigate('/login');
                  setMobileMenuOpen(false);
                }}
              >
                Login
              </Button>
              <Button 
                className="btn-primary w-full flex items-center justify-center gap-2"
                onClick={() => {
                  navigate('/signup');
                  setMobileMenuOpen(false);
                }}
              >
                Sign Up
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
